<template>
    <div class="avatar" :style="{ height: size + 'px' }">
        <span class="avatar-inner" ref="avatar" :title="labelPrefix + displayAltText"  :style="'width: ' + size + 'px; height: ' + size + 'px; ' + (round ? 'border-radius: 50%;' : '')">
            <vue-avatar :custom-style="{backgroundSize: 'cover', backgroundPosition: 'center'}" :src="displayUrl" :rounded="round" v-if="displayAltText" :username="displayAltText" :size="size" :background-color="backgroundColour" :color="colour"></vue-avatar>
            <span v-if="editable" class="avatar-edit">
                <span>Change</span>
            </span>
        </span>
        <ui-popover v-if="editable" ref="avatarOptions" :trigger="$refs.avatar">
            <ui-menu :options="changeAvatarOptions" @select="handleChangeAvatarClick"></ui-menu>
        </ui-popover>
        <ui-tooltip
            v-if="showLabel"
            :trigger="$refs.avatar"
        >{{ tooltipText ? tooltipText : labelPrefix + displayAltText }}</ui-tooltip>
    </div>
</template>

<style lang="scss">
    .avatar-edit { display: none; }
    .avatar { display: inline-block;overflow: hidden; vertical-align: middle; }
    .avatar-inner {
        display: inline-block; overflow: hidden; position: relative;
    }
    .avatar-inner:hover {
        .avatar-edit {
            display:block;
            background: rgba(0,0,0,.4);
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            cursor: pointer;

            & > span {
                display: block;
                position: relative;
                top: 50%;
                left: 52%;
                text-transform: uppercase;
                font-size: .8rem;
                font-weight: bold;
                transform: translate(-50%, -50%);
                color: #fff;
            }
        }
    }
</style>

<script>
    import VueAvatar from 'vue-avatar'

    const changeAvatarOptions = [
        {
            'label': 'Upload a new picture',
            'id': 'upload'
        }, {
            'label': 'Reset',
            'id': 'reset'
        }
    ]

    export default {
        components: { VueAvatar },
        props: {
            editable: {
                type: Boolean,
                default: false,
            },
            url: {
                type: String,
            },
            altText: {
                type: String,
            },
            tooltipText: {
                type: String
            },
            user: { },
            contact: { },
            showLabel: {
                type: Boolean,
                default: true,
            },
            labelPrefix: {
                type: String,
                default: ''
            },
            size: {
                type: Number,
                default: 32
            },
            round: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                changeAvatarOptions
            }
        },
        methods: {
            handleChangeAvatarClick(e) {
                if (e.id === 'upload') {
                    this.$emit('upload')
                } else if (e.id === 'reset') {
                    this.$emit('remove')
                }

                this.$refs.avatarOptions.close();
            }
        },
        computed: {
            colour() {
                 if (this.contact) {
                    return '#fff'
                 }
            },
            backgroundColour() {
                if (this.contact) {
                    return '#ccc'
                }
            },
            displayUrl() {
                if (this.url) {
                    return this.url;
                }

                if (this.user) {
                    return this.user.avatar_url;
                }
            },
            displayAltText() {
                if (this.altText) {
                    return this.altText;
                }

                if (this.user) {
                    return this.user.name;
                }

                if (this.contact) {
                    return this.contact.primary_display_as
                }
            }
        }
    }
</script>